import { createStyles, Theme, StyleRules } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      marginBottom: theme.spacing(3),
    },
  } as StyleRules);
